import { api } from "@/lib/api-client"

import { UsersMeResponse } from "../types/api"

export const getUser = (): Promise<UsersMeResponse> => {
  return api.get("/auth")
}
